import { Bar } from 'react-chartjs-2';
import React from 'react';
import { getTimeStringBySeconds, getHoursFromTimeString } from 'utils/helpers/dateHelpers';
import './chartRegister';

const SECONDS_IN_ONE_HOUR = 3600;

const convertTooltipTime = (context) => {
  const raw = context.raw;

  const seconds = Number(raw.total) * SECONDS_IN_ONE_HOUR;
  const convertedTime = getTimeStringBySeconds(seconds);
  const hours = getHoursFromTimeString(convertedTime);

  const lines = [`Total Time: ${hours}`];

  if (raw.projects && raw.projects.length > 0) {
    raw.projects.forEach((project) => {
      const projectSeconds = Number(project.time) * SECONDS_IN_ONE_HOUR;
      const projectTime = getTimeStringBySeconds(projectSeconds);
      const projectHours = getHoursFromTimeString(projectTime);
      lines.push(`  ${project.title}: ${projectHours}`);
    });
  }

  return lines;
};


const defaultOptions = {
  animation: false,
  datasets: {
    bar: {
      barThickness: 8,
    },
  },
  scales: {
    x: {
      stacked: false,
      offset: true,
      ticks: {
        autoSkip: false,
      },
    },
    y: {
      min: 0,
      max: 24,
      ticks: {
        beginAtZero: true,
      },
    },
  },
  plugins: {
    tooltip: {
      enabled: true,
      callbacks: {
        label: convertTooltipTime,
      }
    }
  }
}

/**
 *
 * @param id{number}
 * @param dateValue{Object}
 * @param requestResult{Object}
 * @returns {number|JSX.Element}
 * @constructor
 */
export const LineChart = ({ labels, datasets }) => {
  const mappedDatasets = datasets.map(dataset => ({
    ...dataset,
    data: dataset.data.map((item, index) => ({
      id: index + 1,
      x: labels[index],
      y: item.total,
      total: item.total,
      projects: item.projects,
    })),
  }));

  return (
    <Bar
      data={{
        labels,
        datasets: mappedDatasets,
      }}
      options={defaultOptions}
    />
  );
};
